import { NgModule } from '@angular/core';

import { SharedModule } from 'shared/shared.module';
import { ComponentsModule } from 'components/components.module';

import { MainContentDrawerComponent } from './main-content-drawer.component';
import { FcpTabModule } from 'fc-ui-components';
import { DownloadCartModule } from '../download-cart/download-cart.module';
import { BulkGtinSearchModule } from '../../content/bulk-search/bulk-search.module';

@NgModule({
    imports: [SharedModule, ComponentsModule, FcpTabModule, DownloadCartModule, BulkGtinSearchModule],
    declarations: [MainContentDrawerComponent],
    exports: [MainContentDrawerComponent]
})
export class MainContentDrawerModule {}
